module.exports = __webpack_public_path__ + "img/conference.4d2a4dad.svg";